import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import tShirt from '../../public/fitkonnekt/merch/t-shirt.png';
import jar from '../../public/fitkonnekt/merch/jar.png';
import cap from '../../public/fitkonnekt/merch/cap.png';
import shorts from '../../public/fitkonnekt/merch/shorts.png';

import styles from './fk-merch.module.css';
import { Container } from '../../components';

function FKMerch() {
  return (
    <section className={styles.merch}>
      <AnimationOnScroll
        animateOnce
        duration={1.2}
        offset={400}
        animateIn="animate__fadeInUp"
      >
        <h2 className={styles.merch_title}>
          Cus<span>tom Merch</span>
        </h2>
      </AnimationOnScroll>

      <Container>
        <AnimationOnScroll
          animateOnce
          duration={1.2}
          animateIn="animate__fadeIn"
          offset={400}
        >
          <div className={styles.merch_inner}>
            <div className={styles.merch_wrapper}>
              <div className={styles.merch_line}>
                <div className={styles.tShirt}>
                  <Image
                    alt="Fitkonnect merch t-shirt"
                    width={625}
                    height={549}
                    src={tShirt}
                  />
                </div>
                <div className={styles.cap}>
                  <Image
                    alt="Fitkonnect merch cap"
                    width={292}
                    height={294}
                    src={cap}
                  />
                </div>
              </div>
              <div className={styles.merch_line}>
                <div className={styles.shorts}>
                  <Image
                    alt="Fitkonnect merch shorts"
                    width={625}
                    height={439}
                    src={shorts}
                  />
                </div>
                <div className={styles.jar}>
                  <Image
                    alt="Fitkonnect merch jar"
                    width={292}
                    height={476}
                    src={jar}
                  />
                </div>
              </div>
            </div>
          </div>
        </AnimationOnScroll>
      </Container>
    </section>
  );
}

export default FKMerch;
